import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyAgenticScoreChange, HttpResponse } from "@/types";

export const rateCandidacyMutationKey = ["rate-candidacy"] as const;

export function useRateCandidacy() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationKey: rateCandidacyMutationKey,
    mutationFn: async ({ candidacyId }: { candidacyId: string }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/rate-candidate`;
      const res = await guacHttpClient.post<
        CandidacyAgenticScoreChange,
        HttpResponse<CandidacyAgenticScoreChange>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
